module.exports = __webpack_public_path__ + "img/683061b81532624b35c122831555db72.png";